import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import {
  DatePicker,
  Loadable,
  SelectField,
  TextField
} from "components/support";
import moment from "moment";

class Filter extends Component {
  static sSaleStatus = [
    { value: "all", label: "Todas as Vendas" },
    { value: "active", label: "Ativas" },
    { value: "cancelled", label: "Canceladas" },
    { value: "cancelled_order", label: "Pedidos Cancelados" },
    { value: "error", label: "Com erro" }
  ];

  handleField = ({ documentNumber, documentSerie }) => {
    const { onFilter } = this.props;
    const value = {};

    value.documentNumber = documentNumber;
    value.documentSerie = documentSerie;

    onFilter(value);
  };

  handleChange = ({ startDate, endDate, saleStatus }) => {
    const options = {};

    if (startDate) {
      options.startDate = startDate.startOf("day");
    }

    if (endDate) {
      options.endDate = endDate.endOf("day");
    }

    if (saleStatus) {
      options.saleStatus = saleStatus;
    }

    this.props.onChange(options);
  };

  render() {
    const { saleStatus } = this.props;
    const { documentNumber, documentSerie } = this.props;

    return (
      <Paper elevation={1} className="p-sm mb-md">
        <Loadable
          loading={this.props.loading}
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column"
          }}
          shadow
        >
          <Typography type="headline">Filtro</Typography>
          <Row>
            <Col xs={12} md={8}>
              <DatePicker
                multiple
                label="Período"
                modal
                fullWidth
                startDate={moment(this.props.dateFrom)}
                endDate={moment(this.props.dateTo)}
                onChange={({ startDate, endDate }) =>
                  this.handleChange({ startDate, endDate })
                }
              />
            </Col>
            <Col xs={12} md={4}>
              <SelectField
                fullWidth
                options={Filter.sSaleStatus}
                label="Status da Venda"
                value={saleStatus}
                onChange={(_, saleStatus) => this.handleChange({ saleStatus })}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={6}>
              <TextField
                fullWidth
                allowClear
                value={documentNumber}
                label="Número do Documento"
                onChange={(_, documentNumber) =>
                  this.handleField({ documentNumber })
                }
              />
            </Col>
            <Col xs={12} lg={6}>
              <TextField
                fullWidth
                allowClear
                value={documentSerie}
                label="Série do Documento"
                onChange={(_, documentSerie) =>
                  this.handleField({ documentSerie })
                }
              />
            </Col>
          </Row>
        </Loadable>
      </Paper>
    );
  }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/app/history/sales/filter/index.jsx